export default __webpack_public_path__ + "static/media/olaf.92cff91f.png";